import { render, staticRenderFns } from "./NewProject.vue?vue&type=template&id=1204c460&scoped=true&"
import script from "./NewProject.vue?vue&type=script&lang=ts&"
export * from "./NewProject.vue?vue&type=script&lang=ts&"
import style0 from "./NewProject.vue?vue&type=style&index=0&id=1204c460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1204c460",
  null
  
)

export default component.exports